import { TransferRequestStatus } from "../api/interface"

export const TRANSFER_REQUEST_STATUS_DETAILS = {
    [TransferRequestStatus.CREATING]: {
        icon: "waitTransfer",
        message: "Запрос на пополнение в обработке",
        isSuccesseful: null,
        isFinal: false,
    },
    [TransferRequestStatus.CREATED]: {
        icon: "waitTransfer",
        message: "Запрос на пополнение отправлен",
        isSuccesseful: null,
        isFinal: false,
    },
    [TransferRequestStatus.CREATE_ERROR]: {
        icon: "errorTransfer",
        message: "Ошибка создания запроса",
        isSuccesseful: false,
        isFinal: true,
    },
    [TransferRequestStatus.ACCEPTING]: {
        icon: "waitTransfer",
        message: "Запрос на пополнение в обработке",
        isSuccesseful: null,
        isFinal: false,
    },
    [TransferRequestStatus.ACCEPTED]: {
        icon: "checkYellow",
        message: "Запрос на пополнение выполнен",
        isSuccesseful: true,
        isFinal: true,
    },
    [TransferRequestStatus.ACCEPT_ERROR]: {
        icon: "errorTransfer",
        message: "Ошибка обработки запроса",
        isSuccesseful: false,
        isFinal: true,
    },
    [TransferRequestStatus.REJECTED]: {
        icon: "errorTransfer",
        message: "Запрос на пополнение со своего счета отклонен",
        isSuccesseful: false,
        isFinal: true,
    },
} as const

export const getStatusDetails = (status: TransferRequestStatus) => TRANSFER_REQUEST_STATUS_DETAILS[status]